export default function ClockIcon(props) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" {...props} xmlns="http://www.w3.org/2000/svg">
            <g id="Icon / FA / Clock / Regular">
                <g id="Icon / FA / Clock / Regular_2">
                    <path fill={props?.fill || "#fff"} id="Vector" d="M11.25 7.75C11.25 7.33437 11.5844 7 12 7C12.4156 7 12.75 7.33437 12.75 7.75V11.6L15.4156 13.375C15.7594 13.6062 15.8531 14.0719 15.5969 14.4156C15.3938 14.7594 14.9281 14.8531 14.5844 14.5969L11.5844 12.5969C11.375 12.4844 11.25 12.25 11.25 11.9719V7.75ZM12 4C16.4187 4 20 7.58125 20 12C20 16.4187 16.4187 20 12 20C7.58125 20 4 16.4187 4 12C4 7.58125 7.58125 4 12 4ZM5.5 12C5.5 15.5906 8.40938 18.5 12 18.5C15.5906 18.5 18.5 15.5906 18.5 12C18.5 8.40938 15.5906 5.5 12 5.5C8.40938 5.5 5.5 8.40938 5.5 12Z" />
                </g>
            </g>
        </svg>

    )
}
